export default "__VITE_ASSET__80cd380d__"